module.exports = __webpack_public_path__ + "static/img/arrow.5c28d015.png";